// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes} from 'react';

// classnames utility
import cx from 'classnames';

// app components
import PasswordValidator from './f_PasswordValidator';

// import customized material UI element
import TextField from '../c_TextField';

// checking password functions
const lowerCaseLetterRegex = /[a-z]/;
const upperCaseLetterRegex = /[A-Z]/;
const oneLowerCase = val => val.split('').some(letter => lowerCaseLetterRegex.test(letter));
const oneUpperCase = val => val.split('').some(letter => upperCaseLetterRegex.test(letter));
const sixCharacterMin = val => val.length >= 6;
const oneNumber = val => val.split('').some(letter => !isNaN(+letter));

function onChange(propsOnChange, event, password) {
  propsOnChange(event, password, sixCharacterMin(password) && oneNumber(password) && oneLowerCase(password) && oneUpperCase(password));
}


export default function PasswordWithValidators(props) {
  return (
      <div className={`password-with-validations ${props.className}`}>
        <TextField className='full-width'
                   floatingLabelText='Password'
                   data-id='Password'
                   password
                   value={props.value}
                   floatingLabelFixed={true}
                   onChange={onChange.bind(this, props.onChange)}
                   onFocus={props.onFocus}
                   onBlur={props.onBlur}/>
        <div className={cx('password-validators-container', 'clearfix', {hide: props.hideWhenEmpty && !props.value})}>
          <PasswordValidator label='One lowercase character' valid={oneLowerCase(props.value)}/>
          <PasswordValidator label='One number' valid={oneNumber(props.value)}/>
          <PasswordValidator label='One uppercase character' valid={oneUpperCase(props.value)}/>
          <PasswordValidator label='Six characters minimum' valid={sixCharacterMin(props.value)}/>
        </div>
      </div>
  );
}

PasswordWithValidators.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  hideWhenEmpty: PropTypes.bool
};

PasswordWithValidators.defaultProps = {
  onChange: () => '',
  onFocus: () => '',
  onBlur: () => '',
  value: ''
};



// WEBPACK FOOTER //
// ./shared/common/components/f_PasswordWithValidators/index.js